module.exports = __webpack_public_path__ + "img/9788958281801.b402f5cb.jpg";